<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="justify-center">
        <v-flex xs12>
          <h3 class="text-center">ADVERSE REACTION/EVENT AND SEVERE ADVERSE EVENT REPORTING FORM</h3>
        </v-flex>
        <v-flex xs12 sm11 md10>
          <v-card flat>
            <v-card-text>
              <form @submit.prevent="saveReport()">
                <v-layout wrap>
                  <v-flex xs12 sm6 md6 lg6 :class="$breakpoint.xsOnly ? '' : 'pr-1'">
                    <v-text-field label="Date" outlined dense prepend-inner-icon="mdi-calendar-month-outline" type="date" required="required" v-model="reaction.date"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6 lg6 :class="$breakpoint.xsOnly ? '' : 'pl-1'">
                    <v-text-field label="Time" outlined dense prepend-inner-icon="mdi-clock-outline" type="time" required="required" v-model="reaction.time"></v-text-field>
                  </v-flex>
                </v-layout>
                <v-autocomplete label="Select Client" :prepend-inner-icon="icons.clients.index" :items="clients" item-value="id" item-text="name" required v-model="reaction.client_id" :readonly="!!client_id" :error-messages="errors.client_id"></v-autocomplete>
                <span v-if="reaction.client_id">
                  <fieldset>
                    <legend>Patient</legend>
                    <v-text-field label="Name" required="required" v-model="reaction.name" dense name="Name" placeholder="Patient's name"></v-text-field>
                    <v-text-field label="Age" required="required" v-model="reaction.age" dense name="Age" placeholder="14 months or 52 years"></v-text-field>
                    <v-text-field label="Sex" required="required" v-model="reaction.sex" dense list="sexes" name="Sex" placeholder="Male/Female"></v-text-field>
                    <datalist id="sexes">
                      <option value="Male"></option>
                      <option value="Female"></option>
                    </datalist>
                  </fieldset><br>
                  <v-text-field label="Location / Residence" v-model="reaction.location" required="required" dense prepend-inner-icon="mdi-map-marker-plus-outline" name="Location"></v-text-field>
                  <fieldset>
                    <legend>.</legend>
                    <v-textarea label="Procedure / RX" v-model="reaction.procedure" :rows="1" auto-grow></v-textarea>
                    <v-textarea label="Onset of event" v-model="reaction.onset_of_event" :rows="1" auto-grow></v-textarea>
                    <v-textarea label="Medical Diagnosis" v-model="reaction.medical_diagnosis" :rows="1" auto-grow></v-textarea>
                    <v-textarea label="Nature of event" v-model="reaction.nature_of_event" :rows="1" auto-grow></v-textarea>
                    <v-textarea label="Action taken" v-model="reaction.action_taken" :rows="1" auto-grow></v-textarea>
                  </fieldset>
                  <fieldset>
                    <legend>.</legend>
                    <v-text-field label="Person Notified" v-model="reaction.person_notified"></v-text-field>
                    <v-text-field label="Contact" v-model="reaction.person_notified_contact" placeholder="+25477........"></v-text-field>
                  </fieldset>
                  <fieldset>
                    <legend>Reporting clinician</legend>
                    <v-text-field label="Name and initials" v-model="reaction.reporting_clinician" required></v-text-field>
                    <v-text-field label="Signed" name="Signed" v-model="reaction.signed" placeholder="Write your name and date" hint="John Doe, 20-Sept-2021" required></v-text-field>
                  </fieldset>
                </span><br>
                <v-btn small type="submit" color="primary" class="pull-right" :loading="reaction.processing">
                  <v-icon left>{{ icons.create }}</v-icon>Submit
                </v-btn>
                <br>
              </form>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/MainLayout'

  export default {
    name: 'CreateAdverseReaction',
    layout,
    props: [
      'clients',
      'client_id',
      'errors',
    ],
    metaInfo () {
      return {
        title: 'Create Adverse Reaction Report',
        titleTemplate: '%s | ' + this.$title,
      }
    },
    data () {
      return {
        reaction: this.$inertia.form({
          client_id: this.client_id,
          date: '',
          name: '',
          age: '',
          sex: '',
          time: '',
          location: '',
          procedure: '',
          onset_of_event: '',
          medical_diagnosis: '',
          nature_of_event: '',
          action_taken: '',
          person_notified: '',
          person_notified_contact: '',
          professional_id: '',
          reporting_clinician: '',
          signed: '',
        })
      }
    },
    methods: {
      fillPatientDetails () {
        let client = this.client
        if (client) {
          this.reaction.name = client.name
          this.reaction.age = client.age
          this.reaction.sex = client.gender
        }
      },
      saveReport () {
        this.reaction.post('/adverse_reactions', {
          preserveScroll: true,
          preserveState: true,
        })
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.fillPatientDetails()
      })
    },
    computed: {
      client () {
        let clients = this.clients
        let id = this.reaction.client_id
        let filtered = clients.filter((client) => {
          return client.id === id;
        })
        return filtered[0]
      }
    },
    watch: {
      'reaction.client_id': 'fillPatientDetails',
    }
  }
</script>
